import type { AxiosError } from "axios";
import type { APIError } from "@/lib/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  retrieveReferralProfile,
  updateReferralProfile,
  searchReferralProfiles,
  type ReferralDirectoryFilters,
} from "@/lib/data/requests/firms/referral-profile";
import { queryKeys } from "@/lib/data/static/query-keys";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import toast from "react-hot-toast";

export const referralProfileQueryOptions = () => ({
  queryKey: [queryKeys.firm, "referral-profile"],
  queryFn: retrieveReferralProfile,
});
export const referralDirectoryQueryOptions = (
  filters: ReferralDirectoryFilters,
) => ({
  queryKey: [queryKeys.firm, "referral-directory", filters],
  initialPageParam: undefined as string | undefined,
  queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
    searchReferralProfiles(filters, pageParam),
  getNextPageParam: (
    page: Awaited<ReturnType<typeof searchReferralProfiles>>,
  ) => page.pagination?.nextCursor,
});
export function useUpdateReferralProfile() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: updateReferralProfile,
    onSuccess: (response) => {
      client.setQueryData(referralProfileQueryOptions().queryKey, response);
      toast.success("Referral profile saved.");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Could not save referral profile.");
    },
  });
}
